import api from "app/api";
import { Options } from "common";

export interface ReviewPartnerItem {
  id: number;
  name: string;
}

export type ReviewPartnerOptions = Options<"role" | "status">;

export function getReviewPartnerService(scope?: any) {
  return api.getService<
    ReviewPartnerItem,
    ReviewPartnerItem,
    ReviewPartnerOptions
  >("review-partners", {
    scope,
    //params goes here
  });
}
